// extracted by mini-css-extract-plugin
export default {"noFiles":"no-files-label_noFiles__eyNgV"};